import { trackEvent } from '@patrianna/analytics'
import { BottomNavigation, BottomNavigationAction } from '@patrianna/core-components'
import { nextTick } from '@patrianna/shared-utils'
import cx from 'classnames'
import { usePathname } from 'next/navigation'

import useMobileBottomNavigation from 'config/mobileBottomNavigation'
import { useRouterPushWithCallback } from 'containers/NavigationProvider'
import useIsAuthPage from 'hooks/useIsAuthPage'
import { useAppSelector } from 'src/store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import { shouldForceVerifyKYCSelector } from 'store/modules/user/selectors'
import { INTERNAL_GAME_NAVIGATION, setDataToSessionStorage } from 'utils/sessionStorage'

import More from './components/More'
import classes from './styles.module.scss'

const pathToEventMap = {
  '/home': 'bottom_menu_home_button_click',
  '/slots/top': 'bottom_menu_games_button_click',
  '/bingo/play/mobile?refererPath=bottomMenu': 'bottom_menu_bingo_button_click',
  '/bingo/sweepstake/play/mobile?refererPath=bottomMenu': 'bottom_menu_bingo_button_click',
  '/search': 'bottom_menu_search_button_click',
}

type Props = {
  isMobile?: boolean
}

function MenuMobile({ isMobile }: Props) {
  const pathname = usePathname()
  const routerPush = useRouterPushWithCallback()
  const isAuthPage = useIsAuthPage()
  const mobileMenuLinks = useMobileBottomNavigation()
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const selectedClass = classes[activeCurrency]
  const isForceShowKYC = useAppSelector(shouldForceVerifyKYCSelector)

  const sendEvent = (path: string) => {
    nextTick().then(() => {
      const eventName = pathToEventMap[path as keyof typeof pathToEventMap]
      trackEvent(eventName)
    })
  }

  return (
    <div className={cx(classes.root, 'mt-hidden-desktop', { [classes.disabled]: isForceShowKYC })} color='default'>
      {isAuthPage === false && (
        <BottomNavigation
          onChange={(e, newValue) => {
            nextTick().then(() => {
              if (mobileMenuLinks[newValue]?.path) {
                sendEvent(mobileMenuLinks[newValue].path)

                routerPush(mobileMenuLinks[newValue].path, () => {
                  window.scrollTo(0, 0)
                })

                if (mobileMenuLinks[newValue].label.toLowerCase().trim() === 'bingo') {
                  setDataToSessionStorage(INTERNAL_GAME_NAVIGATION, 'true')
                }
              }
            })
          }}
          className={classes.root}
        >
          {/* the links should be related to the same list */}
          {[
            ...mobileMenuLinks.map((link) => {
              const isActive = link.path === pathname
              const Icon = link.icon

              return (
                <BottomNavigationAction
                  label={link.label}
                  icon={<Icon />}
                  key={link.id}
                  className={cx(classes.navigationButton, isActive && selectedClass)}
                  data-testid={link.label && `${link.label}-button`}
                />
              )
            }),
            <More key={`more-${mobileMenuLinks.length}`} isMobile={isMobile} />,
          ]}
        </BottomNavigation>
      )}
    </div>
  )
}

export default MenuMobile
